import React, { useEffect } from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import { Checkout2, ErrorPage } from "./pages";
import NewThankyouPage from "./pages/NewThankyouPage";

/** Pushes page_view to GTM on every route change (SPA). */
function GTMPageViewTracker() {
  const location = useLocation();
  useEffect(() => {
    if (typeof window !== "undefined" && window.dataLayer) {
      window.dataLayer.push({
        event: "page_view",
        page_path: location.pathname + location.search,
        page_title: document.title,
      });
      console.log("[GTM] page_view", location.pathname + location.search);
    }
  }, [location.pathname, location.search]);
  return null;
}

const App = () => {
  return (
    <>
      <BrowserRouter>
        <GTMPageViewTracker />
        <Routes>
          <Route path="/" element={<Checkout2 />} />
          <Route path="*" element={<ErrorPage />} />
          <Route path="/ErrorPage" element={<ErrorPage />} />
          <Route path="/thankyou-page" element={<NewThankyouPage />} />
        </Routes>
      </BrowserRouter>
    </>
  );
};

export default App;
